import React from "react";
import Iconify from "@/components/common/Iconify";
import { useUserStore } from "@/store/user";
import {
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";

export const ThemeToggle: React.FC<{
  className?: string;
}> = ({ className }) => {
  const themeMode = useUserStore((state) => state.themeMode);
  const setData = useUserStore((state) => state.setData);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const applyTheme = (next: "light" | "retro" | "dark") => {
    setData("themeMode", () => next);
    setData("isDark", () => next === "dark");

    document.documentElement.dataset.theme = next;
    if (next === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }

    // 兼容：复用原本 localStorage.theme 字段
    localStorage.theme = next;
  };

  const menuItems: Array<{
    mode: "light" | "retro" | "dark";
    label: string;
  }> = [
    { mode: "light", label: "白灰" },
    { mode: "retro", label: "复古色" },
    { mode: "dark", label: "暗色" },
  ];

  return (
    <Menu
      open={isMenuOpen}
      handler={setIsMenuOpen}
      placement="bottom"
      allowHover={true}
    >
      <MenuHandler>
        <button
          className={`${className} p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors`}
          aria-label="主题切换"
        >
          {themeMode === "dark" ? (
            <Iconify icon="material-symbols:light-mode" className="w-5 h-5" />
          ) : themeMode === "retro" ? (
            <Iconify icon="material-symbols:palette" className="w-5 h-5" />
          ) : (
            <Iconify icon="material-symbols:dark-mode" className="w-5 h-5" />
          )}
        </button>
      </MenuHandler>

      {/* 鼠标划入显示三个主题菜单 */}
      <MenuList className="rounded-xl bg-review-page dark:bg-reviewDark-surface border border-review-border dark:border-reviewDark-border">
        {menuItems.map((item) => {
          const active = item.mode === themeMode;
          return (
            <MenuItem
              key={item.mode}
              onClick={() => applyTheme(item.mode)}
              className={[
                "flex items-center justify-start gap-2",
                "rounded-lg",
                active
                  ? "!bg-review-accent !text-white font-semibold !hover:!bg-review-accent !hover:!text-white dark:!bg-reviewDark-accentHover dark:!text-white dark:hover:!bg-reviewDark-accentHover dark:hover:!text-white"
                  : "text-review-text dark:text-reviewDark-muted hover:bg-review-surfaceHover hover:text-review-heading dark:hover:bg-reviewDark-hover dark:hover:text-reviewDark-heading focus:bg-review-surface dark:focus:bg-reviewDark-hover",
              ].join(" ")}
            >
              {item.label}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};
